import { DataBuilderForm, DataBuilderFormProps } from '@integration-app/react'

export default function AdminDataBuilderForm(props: DataBuilderFormProps) {
  return <DataBuilderForm {...props} isAdminMode={true} />
}
